import React, { forwardRef } from 'react'
import { Button } from 'antd'
// import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { DeleteOutlined } from '@ant-design/icons'

function Delete({
  type = 'primary',
  icon = <DeleteOutlined />,
  title = 'button.delete',
  onClick = () => {},
  id = 'btn-delete',
  innerRef,
  ...props
}) {
  const { formatMessage } = useIntl()
  const newTitle = title === 'button.delete' ? formatMessage({ id: title }) : title
  return (
    <Button ref={innerRef} icon={icon} type={type} onClick={onClick} id={id} {...props} danger>
      {newTitle}
    </Button>
  )
}

// Delete.propTypes = {
//   type: PropTypes.string,
//   icon: PropTypes.object,
//   title: PropTypes.string,
//   id: PropTypes.string,
//   onClick: PropTypes.func,
// }

// Delete.defaultProps = {
//   type: 'primary',
//   icon: <DeleteOutlined />,
//   title: 'button.delete',
//   onClick: () => {},
//   id: 'btn-delete',
// }

const DeleteComponent = forwardRef((props, ref) => <Delete {...props} innerRef={ref} />)
DeleteComponent.displayName = 'Delete'

export default DeleteComponent
